var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.3C0 3.57267 1.05789 4.6 2.36842 4.6H7.89474V20.7C7.89474 21.9727 8.95263 23 10.2632 23C11.5737 23 12.6316 21.9727 12.6316 20.7V4.6H18.1579C19.4684 4.6 20.5263 3.57267 20.5263 2.3C20.5263 1.02733 19.4684 0 18.1579 0H2.36842C1.05789 0 0 1.02733 0 2.3ZM27.6316 7.66667H18.1579C16.8474 7.66667 15.7895 8.694 15.7895 9.96667C15.7895 11.2393 16.8474 12.2667 18.1579 12.2667H20.5263V20.7C20.5263 21.9727 21.5842 23 22.8947 23C24.2053 23 25.2632 21.9727 25.2632 20.7V12.2667H27.6316C28.9421 12.2667 30 11.2393 30 9.96667C30 8.694 28.9421 7.66667 27.6316 7.66667Z",
    fill: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.d249bb10df096a8e8c9d92831ec6700d.svg";
export { ForwardRef as ReactComponent };